import React from 'react'

export default function HealthBar({hp}) {
    let width = hp+"%"
  return (
    <div className= "health-bar">
        <span>HP</span>
          <div id="progressbar">
                <div style={{width: width}}>
                </div> 
          </div>
    </div>
  )
}
